import { useMemo } from 'react'

const useGetDefaultCourse = ({
  courseOptions,
  defaultUpfCourseId,
  selectedClass,
  selectedGroup,
  isCurriculumOrCourseChanged
}) => useMemo(() => {
  if (!((selectedClass.value && selectedGroup.value) || isCurriculumOrCourseChanged)) return null;
  return (defaultUpfCourseId && courseOptions.find(course => course?.value === defaultUpfCourseId))
      || courseOptions[0];
}, [selectedClass.value, selectedGroup.value, defaultUpfCourseId, courseOptions.length, isCurriculumOrCourseChanged])

export default useGetDefaultCourse;